<!-- O título e o recolher da seção são do shell. -->
<div [formGroup]="form">
  <p class="section-apoio">
    Texto impresso antes dos itens da proposta.
    @if (isBloqueado && !isSomenteLeitura) {
      <mat-icon class="material-symbols-outlined icone-travado"
        matTooltip="A configuração do orçamento não permite alterar este texto.">lock</mat-icon>
    }
  </p>

  <div class="editor-container" [class.editor-bloqueado]="isBloqueado">
    @if (!isBloqueado) {
      <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
    }
    <ngx-editor
      [editor]="editor"
      formControlName="introducaoProposta"
      [placeholder]="isBloqueado ? '' : 'Texto exibido no início do orçamento...'">
    </ngx-editor>
  </div>
</div>
